import React from "react";
import { useTranslation } from "react-i18next";
import { PRIMARY_600, WHITE_GRAY } from "../../constant/colors";
import useStandardizedTracking, {
  EventNames,
  ContentTypes,
  FeatureGroups
} from "../../utils/pendo/useStandardizedTracking";

import { ReactComponent as ConsentIcon } from "../../assets/svg/consent-icon.svg";

const ManageConsentButton = ({ onClick, label }) => {
  const { t } = useTranslation();
  const { track } = useStandardizedTracking();

  const styles = {
    container: {
      display: "flex",
      justifyContent: "flex-end",
      width: "150px" // Same width as the "Manage Patient Details" button
    },
    button: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "7px",
      backgroundColor: PRIMARY_600,
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      whiteSpace: "nowrap",
      width: "150px",
      height: "32px",
      boxSizing: "border-box"
    },
    icon: {
      fontSize: "24px",
      color: WHITE_GRAY,
      width: "24px",
      height: "24px",
      flexShrink: 0,
      marginRight: "5px"
    },
    text: {
      fontFamily: "Open Sans",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "1.5em",
      color: WHITE_GRAY
    }
  };

  return (
    <div style={styles.container} id="manage_consent_button">
      <button
        style={styles.button}
        onClick={() => {
          // Step 1: Track Pendo event for Manage Consent button click
          track(EventNames.BUTTON_CLICK, {
            pageKey: "patient_overview",
            featureGroup: FeatureGroups.ECONSENT,
            contentType: ContentTypes.CONSENT,
            contentKey: "manage_consent_button",
            additionalInfo: {
              button_text: t("consent.actions.manage_consent"),
              button_id: "btn_manage_consent"
            }
          });

          onClick();
        }}
      >
        <ConsentIcon style={styles.icon} />
        <span style={styles.text}>{label || t("consent.actions.manage_consent")}</span>
      </button>
    </div>
  );
};

export default ManageConsentButton;
